module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-1572d2.c067cf62.png";